import React, { useState } from "react";
import { useFormik } from "formik";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
} from "reactstrap";

import NibbleInput from "../Fields/NibbleInput";
import { changePassword } from "../../helpers/backend_helper";
import { passwordValidation } from "./yup.validation";

const PasswordModal = ({ isOpen, setModal, userId }) => {
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    ...passwordValidation,
    onSubmit: async (values) => {
      save(values);
    },
  });

  const save = (data) => {
    setLoading(true);
    changePassword(userId, data)
      .then(responseAction)
      .finally(() => {
        setLoading(false);
      });
  };

  const responseAction = (response) => {
    if (response.status) {
      handleClose();
    }
  };

  const handleClose = () => {
    setModal((prev) => ({
      ...prev,
      showPassword: false,
    }));

    validation.resetForm();
  };

  return (
    <div>
      <Modal isOpen={isOpen}>
        <ModalHeader className="bg-warning">Cambiar contraseña</ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <NibbleInput
                md={12}
                label="Contraseña:"
                fieldName="password"
                fieldType="password"
                validation={validation}
              />
              <NibbleInput
                md={12}
                label="Repetir contraseña:"
                fieldName="password_confirmation"
                fieldType="password"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default PasswordModal;
